<app-modal size="md" [open]="open()" [title]="title()" (closed)="onCancel()">
    <div class="space-y-4 p-1">
        <div class="flex items-start gap-3 rounded-lg border p-3" [class]="accent().box">
            <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full" [class]="accent().iconWrap">
                <mat-icon class="!text-[22px] !leading-none">{{ icon() }}</mat-icon>
            </div>
            <div>
                <p class="text-md font-medium" [class]="accent().title">{{ bodyText() }}</p>
                @if (warning()) {
                    <p class="mt-1 text-xs" [class]="accent().sub">{{ warning() }}</p>
                }
            </div>
        </div>
    </div>

    <div class="flex justify-end gap-3 border-t border-gray-200 pt-4" modal-footer>
        <app-button variant="secondary" [disabled]="loading()" [label]="cancelLabel()" (clicked)="onCancel()" />
        <app-button
            [disabled]="loading()"
            [icon]="confirmIcon()"
            [label]="confirmLabel()"
            [loading]="loading()"
            [variant]="buttonVariant()"
            (clicked)="onConfirm()" />
    </div>
</app-modal>
